import { useState, useEffect } from 'react'
import SectionTitle from '../../common/SectionTitle'
import Slick from 'react-slick'

import './_StepsSection.scss'

import mobSlide1 from '../../../assets/images/steps-section/img1.png'
import mobSlide2 from '../../../assets/images/steps-section/img2.png'
import mobSlide3 from '../../../assets/images/steps-section/img3.png'

const StepCard = ({ img, text }) => (
  <div className='step-card'>
    <div className='img-box'>
      <img src={img} alt={text} />
    </div>
    <div className='text-box center'>
      <p className='text'>{text}</p>
    </div>
  </div>
)

const stepCards = [{
  img: mobSlide1,
  text: 'Download the app'
}, {
  img: mobSlide2,
  text: 'Take a health survey or make an appointment'
}, {
  img: mobSlide3,
  text: 'Come to the reception',
}]

const StepsSection = () => {
  const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)

  const resizeWindow = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', resizeWindow)

    return () => window.removeEventListener('resize', resizeWindow)
  })

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <div className='StepsSection section-padding'>
      <div className='container'>
        <SectionTitle
          title='Getting started easily'
          text='Three easy steps to begin'
        />
        <div className='slider-box'>
          { windowWidth < 834 ?
            <Slick {...settings}>
              {stepCards.map(card => <StepCard {...card} key={card.text} />)}
            </Slick> :
            stepCards.map(card => <StepCard {...card} key={card.text} />)
          }
        </div>
      </div>
    </div>
  )
}

export default StepsSection
